import { createFileRoute } from '@tanstack/react-router';
import { FichaInsumoView } from '@/modules/agronomia/components/FichaInsumoView';

// Tela 07 · Produto — Ficha: detalhe de um insumo do catálogo (desktop).
export const Route = createFileRoute('/_authed/agronomia_/insumos_/$id')({
  component: FichaInsumoPage,
});

function FichaInsumoPage() {
  const { id } = Route.useParams();
  return <FichaInsumoView insumoId={Number(id)} />;
}
